import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const Footer=()=> {
  const [cookieIsAccepted,setCookieIsAccepted]=useState(true)
  const [ageIsAccepted,setAgeIsAccepted]=useState(true)

  useEffect(()=>{
const value=localStorage.getItem("cookie")
const ageValue=localStorage.getItem("age")
if(value)
{
  setCookieIsAccepted(false)
}
if(ageValue)
  {
    setAgeIsAccepted(false)
  }
  },[])

const acceptCookie=()=>{
  setCookieIsAccepted(false)
  localStorage.setItem("cookie",true)
}
const acceptAge=()=>{
  setAgeIsAccepted(false)
  localStorage.setItem("age",true)
}

  return (
    <>
<footer>
    <div
        style={{
          fontSize: "12px",
          color: "#666",
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#f9f9f9",
        }}
    >
        <p>
            <strong>Ansvarsfraskrivelse (Disclaimer):</strong>
            <br />
            Dette nettstedet tilbyr kun sosiale kasinospill for underholdningsformål. Spillene involverer ikke ekte penger, og det er ingen mulighet for å vinne pengepremier eller andre verdier. Suksess i disse spillene bør ikke tolkes som en indikasjon på suksess i pengespill med ekte penger.
            <br /><br />
            <strong>Aldersgrense:</strong>
            <br />
            Nettstedet og dets innhold er kun tilgjengelig for personer over 18 år. Hvis du er under denne aldersgrensen, ber vi deg om ikke å bruke tjenesten.
            <br /><br />
            <strong>Ansvarlig spill:</strong>
            <br />
            Spill skal være en kilde til underholdning. Hvis du opplever problemer knyttet til spillvaner, anbefaler vi at du besøker 
            <a
                href="https://www.gamblingtherapy.org/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007BFF" }}
            >
                denne siden
            </a> for støtte og hjelp.
        </p>
    </div>
    
    <div className="bottom-row mt-3 mb-3">
        <div className="container d-flex align-items-center justify-content-between">
            <div className="logo-wrapper d-flex align-items-center justify-content-between">
                <a href="/">
                    <img src="/logo.png" alt="Crazy Monkey Slot Logo"/>
                </a>
                <a href="/" className="main-logo-text">
                    <p className="game-name">
                        Crazy Monkey
                    </p>
                    <span>
                        Ditt Gratis Sosiale Kasino
                    </span>
                </a>
            </div>
            <div className="navigation">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <rect x="4" y="7.5" width="16" height="1.5"></rect>
                    <rect x="4" y="15" width="16" height="1.5"></rect>
                </svg>
                <ul className="nav-list d-flex align-items-center justify-content-center">
                    <li>
                        <a href="/">
                            Hjem
                        </a>
                    </li>
                    <li>
                        <a href="contact-us">
                            Kontakt oss
                        </a>
                    </li>
                    <li>
                        <a href="privacy-policy">
                            Retningslinjer for personvern
                        </a>
                    </li>
                    <li>
                        <a href="terms-and-conditions">
                            Vilkår og betingelser
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>


{
    cookieIsAccepted &&(
      <div className="cookie-banner" id="cookie-banner" style={{display:'flex'}}>
      <p>Vi bruker informasjonskapsler (cookies) for å forbedre ytelsen og brukeropplevelsen på nettstedet vårt. Ved å fortsette å bruke nettstedet, samtykker du til vår bruk av informasjonskapsler. For mer informasjon, vennligst se vår personvernerklæring.
      </p>
      <button  onClick={()=>acceptCookie()}  id="accept-cookies">Submit</button>
  </div>
    )
  }
  {
   ageIsAccepted && (
    <div className="age-check-popup" id="age-check-popup">
      <div className="popup-inner-wrapper">
        <h3 className="text-center">
          Aldersbekreftelse
        </h3>
        <p className="popup-text text-center">
          Denne tjenesten er kun tilgjengelig for personer over <span>18</span> år. Vennligst bekreft alderen din for å fortsette.
        </p>
        <button 
          type="button" 
          onClick={() => acceptAge()} 
          className="text-center popup-btn"
        >
          Bekreft
        </button>
      </div>
    </div>
  )
  }
    </>

  );
}

export default Footer;